import { type MantineSize, Text } from "@mantine/core";
import { forwardRef } from "react";

type NavSectionTextLabelProps = {
	label: string;
	className?: string;
	size: MantineSize | undefined;
};

const NavSectionTextLabel = forwardRef<
	HTMLDivElement,
	NavSectionTextLabelProps
>((props, ref) => {
	return (
		<Text className={props.className} truncate="end" fz={props.size} ref={ref}>
			{props.label}
		</Text>
	);
});

export default NavSectionTextLabel;
